{
    "Page_Title": "Admin Actions",

    "Action_Label_MC": "Make Call",
    "Action_Label_MCC": "Consultation Call",
    "Action_Label_MDT": "Dial DTMF Tone",
    "Action_Label_CC": "Clear Call (Via Call Control)",
    "Action_Label_CCCM": "Clear Call (Via Call Model)",
    "Action_Label_CX": "Clear Connection",
    "Action_Label_AC": "Answer Call",
    "Action_Label_HD": "Hold Call",
    "Action_Label_PC": "Park Call",
    "Action_Label_RC": "Retrieve Call",
    "Action_Label_ATC": "Alternate Call",
    "Action_Label_PUC": "Pickup Call",
    "Action_Label_TO": "Transfer One Step",
    "Action_Label_TR": "Transfer Complete",
    "Action_Label_DF": "Divert/Deflect Call",
    "Action_Label_MONC": "Monitor Connection",
    "Action_Label_REC": "Record Call",
    "Action_Label_CBMSG": "Register Callback",
    "Action_Label_CO": "Conference Join",
    "Action_Label_MES": "Monitor Start",
    "Action_Label_MEP": "Monitor Stop",
    "Action_Label_SDND": "Set DNS Status",
    "Action_Label_SACD": "Set ACD Status",
    "Action_Label_SFWD": "Set Forward Status",
    "Action_Label_SACC": "Set Account Code",
    "Action_Label_SPWD": "Set Entity Password",
    "Action_Label_QDND": "Query DND Status",
    "Action_Label_QACD": "Query ACD Status",
    "Action_Label_QFWD": "Query Forward Status",
    "Action_Label_SPC": "Snapshot Call",
    "Action_Label_SPD": "Snapshot Device",

    "AcdOption_SignIn": "Sign In",
    "AcdOption_SignOut": "Sign Out",
    "AcdOption_Available": "Available",
    "AcdOption_NotAvailable": "Not-Available",
    "AcdOption_AlertingAcd": "Alerting (ACD)",
    "AcdOption_AlertingNonAcd": "Alerting (Non ACD)",
    "AcdOption_BusyAcd": "Busy (ACD)",
    "AcdOption_BusyNonAcd": "Busy (Non ACD)",
    "AcdOption_BusySupervisor": "Busy (Supervisor)",
    "AcdOption_AcdDnd": "ACD-DND",
    "AcdOption_WrapUp": "Wrap Up",

    "ForwardOption_None": "None",
    "ForwardOption_Immediate": "Immediate",
    "ForwardOption_OnBusy": "On Busy",
    "ForwardOption_NoAnswer": "No Answer",
    "ForwardOption_OnDnd": "On DND",
    "ForwardOption_OnOos": "On OOS",

    "Field_Label_DeviceMain": "Device",
    "Field_Label_Destination": "Destination",
    "Field_Label_CallIDMain": "Active CallID",
    "Field_Label_DestinationAutoPrefix": "Auto Prefix Destination?",
    "Field_Label_CallIDHeld": "Other CallID",
    "Field_Label_DTMFTones": "DTMF Tones",
    "Field_Label_ParkLocation": "Park Location",
    "Field_Label_OtherCallID": "Other CallID",
    "Field_Label_DeviceToPickupAt": "Device to Pickup At",
    "Field_Label_CallParked": "Call Parked",
    "Field_Label_MonitorType": "Monitor Type",
    "Field_Label_Password": "Password",
    "Field_Label_UseSecurePassword": "Use Secure Password?",
    "Field_Label_MonitorCrossRefID": "Monitor Cross Ref ID",
    "Field_Label_IsDND": "DND On/Off",
    "Field_Label_AgentID": "Agent ID",
    "Field_Label_ACDGroup": "ACDGroup",
    "Field_Label_ACDStateReasonTextID": "ACDStateReasonTextID",
    "Field_Label_ACDStatus": "ACD Status",
    "Field_Label_ForwardMode": "Forward Status",
    "Field_Label_AccountCode": "Account Code",
    "Field_Label_PasswordOld": "Old Password",
    "Field_Label_PasswordNew": "New Password",

    "Field_Label_TelephonyServer": "Telephony Server",
    "Field_Label_Partition": "Partition",
    "Field_Label_CME": "CME",

    "Action_Button_Label_Execute": "Execute",
    "Action_Button_Label_Reset": "Reset",

    "NAME": "AdminActionsLanguage"
}
